import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getCoinDetail } from "../../../actions/getCoinDetail";
import { isEmpty } from "lodash";
import { usersMakeOrders } from "../../../services/adminServices";
import { num2English, showPrice } from "../../../utils/priceFunc";
import { userCoinBalance } from "../../../actions/user";
import Num2persian from "num2persian";
//Components
import LayoutCoin from "./LayoutCoin";
import ErrorMessageHook from "../../../helpers/errors_notifications/ErrorMessage";
import { errorMessage, successMessage } from "../../../utils/messages";
import { coinUsersBalance } from "../../../services/userServices";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../actions/loadingPage";
//Styles and Icons
import styles from "./BuySell.module.scss";
import VerticalIcon from "../../../styles/icon/menu/Vertical_switch.svg";
import copyIcon from "../../../styles/icon/CopyIcon2.svg";
export default function BuyCoin() {
  const history = useHistory();
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [switchButton, setSwitchButton] = useState(false);
  const [coinValue, setCoinValue] = useState("");
  const [priceValue, setPriceValue] = useState("");
  const [messageBox, setMessageBox] = useState("");
  const [coinUserBalance, setCoinUserBalance] = useState({});
  const { name } = useParams();
  //State's
  const COIN_DATA = useSelector((state) => state.coinInfo.data);
  const userId = useSelector((state) => state.userId);
  const userRial = useSelector((state) => state.fullUserInfo.coinBalance);
  //End State's
  ///// CALCULATOR
  const changeRialPrice = (e) => {
    const calc = num2English(e.target.value)?.replace(/\D/g, "");
    setPriceValue(calc);
    setCoinValue(calc / COIN_DATA?.arzfi_price);
  };
  const changeCoinPrice = (e) => {
    const calc = num2English(e.target.value)?.match(/\d|\./g)?.join("") || "";
    setCoinValue(calc);
    const rialValue = calc * +COIN_DATA?.arzfi_price;
    setPriceValue(rialValue.toString()?.split(".")[0]);
  };
  ///// End Calculator
  const dispatch = useDispatch();
  useEffect(() => {
    let mounted = true;
    const getThisCoinInfo = async () => {
      try {
        await dispatch(getCoinDetail(name));
        dispatch(hiddenLoadingPage());
      } catch (ex) {
        dispatch(showLoadingPage());
      }
    };
    //
    (async () => {
      dispatch(showLoadingPage());
      if (mounted) {
        await getThisCoinInfo();
        dispatch(userCoinBalance("irt"));
        getUserThisCoinBalance();
      }
    })();
    //
    const reloadInfo = setInterval(() => {
      getThisCoinInfo();
    }, 30000);
    return () => {
      clearInterval(reloadInfo);
      mounted = false;
    };
  }, []);

  const replaceToAmount = () => {
    let amount = Number(userRial.asset.balance - userRial.asset.locked) || 0;
    setPriceValue(amount);
    setCoinValue(amount / COIN_DATA?.arzfi_price);
  };

  const getUserThisCoinBalance = async () => {
    const { data } = await coinUsersBalance(name);
    setCoinUserBalance(data);
  };
  //Buy, API
  const handleBuyCoin = async (e) => {
    e.preventDefault();
    if (!+priceValue) return setMessageBox("تعداد یا مبلغ خرید وارد نشده است");
    if (+coinValue < +COIN_DATA.minAmount)
      return setMessageBox(
        `حداقل مقدار خرید ${COIN_DATA.faName} ${COIN_DATA.minAmount}`
      );
    if (+coinValue > +COIN_DATA.maxAmount)
      return setMessageBox(
        `حداکثر مقدار خرید ${COIN_DATA.faName} ${COIN_DATA.maxAmount}`
      );
    if (+userRial.asset.balance - +userRial.asset.locked < +priceValue)
      return setMessageBox("موجودی حساب شما کافی نمیباشد");

    const body = {
      asset: name,
      confirmed: false,
      orderAmount: +priceValue,
      orderType: "buy",
    };
    try {
      setDisabledBtn(true);
      const { data } = await usersMakeOrders(body);
      if (data.error) {
        errorMessage(data.error);
      } else {
        successMessage(data.message);
        setPriceValue(0);
        setCoinValue(0);
        dispatch(userCoinBalance("irt"));
        getUserThisCoinBalance();
      }
    } catch (ex) {
      errorMessage("دوباره تلاش کنید");
    } finally {
      setDisabledBtn(false);
    }
  };

  return (
    <>
      <LayoutCoin>
        {messageBox && (
          <ErrorMessageHook
            setMessageBox={setMessageBox}
            messageBox={messageBox}
          />
        )}

        <div className={styles.buyCoin_container}>
          <form onSubmit={(e) => handleBuyCoin(e)}>
            {switchButton ? (
              <>
                <div className={styles.second_input}>
                  <input
                    className="changeBackgroundToWhite"
                    onChange={changeRialPrice}
                    value={isNaN(priceValue) ? "" : priceValue}
                    inputMode="decimal"
                  />
                  <div
                    className={`changeFontColorToBlack ${styles.second_input_placeholder}`}
                  >
                    مبلغ کل(تومان)
                  </div>
                </div>
                {priceValue && (
                  <div
                    className={`font_color_white ${styles.show_persian_price}`}
                  >
                    {Num2persian(priceValue)} تومان
                  </div>
                )}
                <div className={styles.user_wallet_amount}>
                  <div className={`font_color_white ${styles.title_count}`}>
                    موجودی کیف پول شما:
                  </div>
                  <div
                    className={`font_color_white ${styles.user_coins}`}
                    onClick={() => replaceToAmount()}
                  >
                    <div className={styles.symbol_coin}>
                      <img
                        src={copyIcon}
                        alt="bbb"
                        width={14}
                        height={14}
                        className="convertPicToGreen"
                      />{" "}
                      تومان
                    </div>
                    <div className={styles.coin_amount}>
                      {(userRial?.asset &&
                        showPrice(
                          +userRial.asset.balance - +userRial.asset.locked
                        )) ||
                        0}
                    </div>
                  </div>
                </div>
                <div className={styles.switch_container}>
                  <div
                    className={styles.button_change_to_sell}
                    onClick={() => setSwitchButton(!switchButton)}
                  >
                    <img src={VerticalIcon} alt="" width={20} height={20} />
                  </div>
                </div>
                <div className={styles.first_input}>
                  <input
                    className="changeBackgroundToWhite"
                    disabled
                    readOnly
                    value={isNaN(priceValue) ? "" : showPrice(coinValue)}
                  />
                  <div
                    className={`changeFontColorToBlack ${styles.first_input_placeholder}`}
                  >
                    مقدار({COIN_DATA?.faName})
                  </div>
                </div>
                <div className={styles.user_coin_count}>
                  <div className={`font_color_white ${styles.title_count}`}>
                    موجودی کیف پول شما:
                  </div>
                  <div className={`font_color_white ${styles.user_coins}`}>
                    <div className={styles.symbol_coin}>
                      {COIN_DATA?.symbol}
                    </div>
                    <div className={styles.coin_amount}>
                      {(coinUserBalance?.asset &&
                        +coinUserBalance.asset.balance -
                          +coinUserBalance.asset.locked) ||
                        0}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={styles.first_input}>
                  <input
                    className="changeBackgroundToWhite"
                    onChange={changeCoinPrice}
                    value={coinValue}
                    inputMode="decimal"
                  />
                  <div
                    className={`changeFontColorToBlack ${styles.first_input_placeholder}`}
                  >
                    مقدار({COIN_DATA?.faName})
                  </div>
                </div>
                <div className={styles.user_coin_count}>
                  <div className={`font_color_white ${styles.title_count}`}>
                    موجودی کیف پول شما:
                  </div>
                  <div className={`font_color_white ${styles.user_coins}`}>
                    <div className={styles.symbol_coin}>
                      {COIN_DATA?.symbol}
                    </div>
                    <div className={styles.coin_amount}>
                      {(coinUserBalance?.asset &&
                        +coinUserBalance.asset.balance -
                          +coinUserBalance.asset.locked) ||
                        0}
                    </div>
                  </div>
                </div>
                <div className={styles.switch_container}>
                  <div
                    className={styles.button_change_to_sell}
                    onClick={() => setSwitchButton(!switchButton)}
                  >
                    <img src={VerticalIcon} alt="" width={20} height={20} />
                  </div>
                </div>
                <div className={styles.second_input}>
                  <input
                    className="changeBackgroundToWhite"
                    disabled
                    readOnly
                    value={priceValue === "NaN" ? "" : showPrice(priceValue)}
                  />
                  <div
                    className={`changeFontColorToBlack ${styles.second_input_placeholder}`}
                  >
                    مبلغ کل(تومان)
                  </div>
                </div>
                {priceValue && (
                  <div
                    className={`font_color_white ${styles.show_persian_price}`}
                  >
                    {Num2persian(priceValue)} تومان
                  </div>
                )}
                <div className={styles.user_wallet_amount}>
                  <div className={`font_color_white ${styles.title_count}`}>
                    موجودی کیف پول شما:
                  </div>
                  <div
                    className={`font_color_white ${styles.user_coins}`}
                    onClick={() => replaceToAmount()}
                  >
                    <div className={styles.symbol_coin}>
                      <img
                        src={copyIcon}
                        alt="bbb"
                        width={12}
                        height={12}
                        className="convertPicToGreen"
                      />{" "}
                      تومان
                    </div>
                    <div className={styles.coin_amount}>
                      {(userRial?.asset &&
                        showPrice(
                          +userRial.asset.balance - +userRial.asset.locked
                        )) ||
                        0}
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className={styles.button_place}>
              <button
                className={styles.button_green}
                type="submit"
                disabled={isEmpty(userId) ? true : disabledBtn}
              >
                خرید <span>{COIN_DATA?.faName}</span>
              </button>
            </div>
          </form>
          {isEmpty(userId) ? (
            <div className={styles.message_for_login}>
              ابتدا وارد{" "}
              <span onClick={() => history.push("/authorization/login")}>
                حساب کاربری
              </span>{" "}
              خود شوید
            </div>
          ) : (
            ""
          )}
        </div>
      </LayoutCoin>
    </>
  );
}
